// ── Product Filter ─────────────────────────────────────────────────────
(function () {
  document.querySelectorAll('[data-filter-widget]').forEach(function (widget) {
    var fields = widget.querySelectorAll('.gc-product-filter__field');

    // ── Toggle dropdown open/close ──────────────────────────────────
    fields.forEach(function (field) {
      var trigger  = field.querySelector('.gc-product-filter__trigger');
      var dropdown = field.querySelector('.gc-product-filter__dropdown');
      if (!trigger || !dropdown) return;

      trigger.addEventListener('click', function () {
        var isOpen = trigger.getAttribute('aria-expanded') === 'true';

        // Close all other dropdowns first
        fields.forEach(function (f) {
          var t = f.querySelector('.gc-product-filter__trigger');
          var d = f.querySelector('.gc-product-filter__dropdown');
          if (t && d && f !== field) {
            t.setAttribute('aria-expanded', 'false');
            d.hidden = true;
          }
        });

        trigger.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
        dropdown.hidden = isOpen;
      });
    });

    // ── Close on click outside ──────────────────────────────────────
    document.addEventListener('click', function (e) {
      if (!widget.contains(e.target)) {
        fields.forEach(function (field) {
          var t = field.querySelector('.gc-product-filter__trigger');
          var d = field.querySelector('.gc-product-filter__dropdown');
          if (t && d) {
            t.setAttribute('aria-expanded', 'false');
            d.hidden = true;
          }
        });
      }
    });

    // ── Navigate on checkbox change ─────────────────────────────────
    widget.addEventListener('change', function (e) {
      if (!e.target.classList.contains('gc-product-filter__checkbox')) return;

      var params = new URLSearchParams(window.location.search);

      fields.forEach(function (field) {
        var tax = field.dataset.taxonomy;
        var checked = field.querySelectorAll('.gc-product-filter__checkbox:checked');
        var slugs = [];
        checked.forEach(function (cb) { slugs.push(cb.value); });

        if (slugs.length > 0) {
          params.set(tax, slugs.join(','));
        } else {
          params.delete(tax);
        }
      });

      var base = widget.dataset.baseUrl || window.location.pathname;
      var qs = params.toString();
      window.location.href = qs ? base + '?' + qs : base;
    });
  });
})();
